import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, formatDate, getCurrentDateTime,request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import SearchIcon from '@mui/icons-material/Search';
import { RECEIPT_MODE, VOUCHER_TYPE_DROPDOWN } from '../../../../../constants';
import { SelectDoctorTable } from '../masters/others/SelectDoctorTable';

const TABLE_HEADER = [
  {
    header: ' Date',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'Bill No',
    accessor: 'bill_no'
  },
  {
    header: 'UHID No',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.patient?.name}`}
        </span>
      );
    }
  },
  {
    header: 'Sponsor',
    accessor: 'patient.sponsor_name'
  },
  {
    header: 'Mobile No',
    accessor: 'patient.mobile_no'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const IPD_BILLING_TABLE_HEADER = [
  {
    header: ' Date',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'Bill No',
    accessor: 'bill_no'
  },
  {
    header: 'UHID No',
    accessor: (row) => row?.indoorRegisteration?.uhid
  },
  {
    header: 'IPD No',
    accessor: (row) => row?.ipd_no
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.patient?.name}`}
        </span>
      );
    }
  },
  {
    header: 'Sponsor',
    accessor: 'patient.sponsor_name'
  },
  {
    header: 'Mobile No',
    accessor: 'patient.mobile_no'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const PARTIAL_CANCELLATION_TABLE_HEADER = [
  {
    header: 'Cancellation No',
    accessor: (row) => row?.cancellation_no
  },
  {
    header: ' Date',
    accessor: (row) => `${formatDate(row?.cancellation_date)}`
  },
  {
    header: 'UHID No',
    accessor: (row) => row?.uhid
  },
  {
    header: 'IPD No',
    accessor: (row) => row?.ipd_no
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.patient?.name}`}
        </span>
      );
    }
  },
  {
    header: 'Sponsor',
    accessor: 'patient.sponsor_name'
  },
  {
    header: 'Mobile No',
    accessor: 'patient.mobile_no'
  },
  {
    header: 'Authority',
    accessor: 'authority.authority'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const SERVICE_ITEMS_TABLE_HEADER = [
  {
    header: 'Voucher Type',
    accessor: 'voucher_type'
  },
  {
    header: 'Service Name',
    accessor: 'service_name'
  },
  {
    header: 'Amount',
    accessor: 'amount'
  },
  {
    header: 'Discount Amount.',
    accessor: (row) => (row?.disc_amt === 0 ? '0' : row?.disc_amt)
  },
  {
    header: 'Receipt Amount',
    accessor: 'amount'
  }
];

const initialOPDBillingDataObj = {
  data: [],
  loading: false
};

const initialIPDBillingDataObj = {
  data: [],
  loading: false
};

const initialPartialCancellationDataObj = {
  data: [],
  loading: false
};

export const PartialCancellation = () => {
  const doctorIDRef = useRef();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [opdBillingSelectedRecord, setOpdBillingSelectedRecord] = useState([]);
  const [ipdBillingSelectedRecord, setIpdBillingSelectedRecord] = useState([]);
  const [opdBillingDataObj, setOpdBillingDataObj] = useState(initialOPDBillingDataObj);
  const [ipdBillingDataObj, setIpdBillingDataObj] = useState(initialIPDBillingDataObj);
  const [partialCancellationDataObj, setPartialCancellationDataObj] = useState(initialPartialCancellationDataObj);
  const [authorityMaster, setAuthorityMaster] = useState([]);
  const [reasonMaster, setReasonMaster] = useState([]);
  const [openOpdBillingDialog, setOpenOpdBillingDialog] = useState(false);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [opdInput, setOpdInput] = useState('');
  const [openIpdBillingDialog, setOpenIpdBillingDialog] = useState(false);
  const [ipdInput, setIpdInput] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [input, setInput] = useState('');

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        uhid: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      cancellation_date: new Date().toISOString().split('T')[0],
      time: getCurrentDateTime('time'),
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  const getAuthorityDropdown = useCallback(async () => {
    const data = await dropdownFetch('authority-master');
    setAuthorityMaster(data);
  }, []);

  const getReasonMasterDropdown = useCallback(async () => {
    const data = await dropdownFetch('reason-master');
    setReasonMaster(data);
  }, []);

  useEffect(
    () => {
      getAuthorityDropdown();
      getReasonMasterDropdown();
    },
    getAuthorityDropdown,
    getReasonMasterDropdown
  );

  useEffect(() => {
    if (selectedRecord) {
      console.log(selectedRecord, 'SELECTED RECORD IS HERE...');
      setValue('bill_no', selectedRecord.bill_no);
      setValue('uhid', selectedRecord.uhid);
      setValue('ipd_no', selectedRecord.ipd_no);
      setValue('patient_name', selectedRecord.patient?.name);
      setValue('cancellation_no', selectedRecord?.cancellation_no);
      setValue('patient_name', selectedRecord?.patient?.name);
      setValue('authority', selectedRecord?.authority?._id);
      setValue('cancel_reason', selectedRecord?.cancel_reason?._id);
      setValue('remarks', selectedRecord?.remarks);
      const formattedbillDate = selectedRecord.cancellation_date
        ? new Date(selectedRecord.cancellation_date).toISOString().split('T')[0]
        : '';
      setValue('cancellation_date', formattedbillDate);
      const serviceDate = selectedRecord.indoorService?.date || selectedRecord.opdService?.date;
      const formattedBillingDate = serviceDate ? new Date(serviceDate).toISOString().split('T')[0] : '';
      setValue('bill_date', formattedBillingDate);
      setValue('voucher_type', selectedRecord?.voucher_type);
      const PayMode = selectedRecord.indoorService?.pay_mode || selectedRecord.opdService?.pay_mode;
      setValue('pay_mode', PayMode);
      setDetailList(selectedRecord?.service_items);
    } else {
      reset();
    }
  }, [selectedRecord]);

  useEffect(() => {
    if (opdBillingSelectedRecord) {
      console.log(opdBillingSelectedRecord);
      setValue('bill_no', opdBillingSelectedRecord.bill_no);
      setValue('uhid', opdBillingSelectedRecord.uhid);
      setValue('patient_name', opdBillingSelectedRecord.patient?.name);
      setValue('pay_mode', opdBillingSelectedRecord?.pay_mode);
      const formattedbillDate = opdBillingSelectedRecord.date
        ? new Date(opdBillingSelectedRecord.date).toISOString().split('T')[0]
        : '';
      setValue('bill_date', formattedbillDate);
      const updatedServiceItems = opdBillingSelectedRecord?.service_items?.map((data) => ({
        ...data,
        voucher_type: watch('voucher_type')
      }));
      setDetailList(updatedServiceItems);
    } else {
      reset();
    }
  }, [opdBillingSelectedRecord]);

  useEffect(() => {
    if (ipdBillingSelectedRecord) {
      console.log(ipdBillingSelectedRecord);
      setValue('bill_no', ipdBillingSelectedRecord?.bill_no);
      setValue('uhid', ipdBillingSelectedRecord?.patient?.uhid);
      setValue('ipd_no', ipdBillingSelectedRecord.ipd_no);
      setValue('patient_name', ipdBillingSelectedRecord.patient?.name);
      setValue('pay_mode', ipdBillingSelectedRecord?.pay_mode);
      const formattedbillDate = ipdBillingSelectedRecord.date
        ? new Date(ipdBillingSelectedRecord.date).toISOString().split('T')[0]
        : '';
      setValue('bill_date', formattedbillDate);
      const updatedServiceItems = ipdBillingSelectedRecord?.service_items?.map((data) => ({
        ...data,
        voucher_type: watch('voucher_type')
      }));
      setDetailList(updatedServiceItems);
    } else {
      reset();
    }
  }, [ipdBillingSelectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
const createUrl =
  watch('voucher_type') === 'OPD BILLING'
    ? '/partial-cancellation-opd-billing-create'
    : watch('voucher_type') === 'IPD BILLING'
      ? '/partial-cancellation-ipd-billing-create'
      : '';
    const response = await request(editFlag ? '/partial-cancellation-update' : `${createUrl}`, {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: { ...formValues, service_items: selectedRows }
    });
    if(response?.success){
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Partial Cancellation`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
    }else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Partial Cancellation`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setPartialCancellationDataObj({ loading: true });
    const response = await request('/partial-cancellation-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setPartialCancellationDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setPartialCancellationDataObj({ loading: false });
    }
  };

  const fetchOpdBillingList = async () => {
    setOpenOpdBillingDialog(true);
    setOpdBillingDataObj({ loading: true });
    const response = await request('/opd-billing-active-service-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setOpdBillingDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setOpdBillingDataObj({ loading: false });
    }
  };

  const fetchIpdBillingList = async () => {
    setOpenIpdBillingDialog(true);
    setIpdBillingDataObj({ loading: true });
    const response = await request('/ipd-billing-active-service-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setIpdBillingDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setIpdBillingDataObj({ loading: false });
    }
  };

  const handleOpdChange = (e) => {
    setOpdInput(e.target.value);
  };

  const handleIpdChange = (e) => {
    setIpdInput(e.target.value);
  };

  useEffect(() => {
    handleSearchOpdBilling();
  }, [opdInput]);

  useEffect(() => {
    handleSearchIpdBilling();
  }, [ipdInput]);

  const handleSearchOpdBilling = async () => {
    const lowercasedInput = opdInput.toLowerCase().trim();
    setOpdBillingDataObj({ loading: true, data: [] });
    try {
      const query = {};
      if (lowercasedInput) {
        query.patientName = lowercasedInput;
      }
      const response = await request('/opd-billing-active-service-list', {
        method: 'GET',
        query: query
      });
      if (response.success && Array.isArray(response.data)) {
        const filteredData = response.data.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setOpdBillingDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setOpdBillingDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setOpdBillingDataObj({ loading: false, data: [] });
    }
  };

  const handleSearchIpdBilling = async () => {
    const lowercasedInput = ipdInput.toLowerCase().trim();
    setIpdBillingDataObj({ loading: true, data: [] });
    try {
      const query = {};
      if (lowercasedInput) {
        query.patientName = lowercasedInput;
      }
      const response = await request('/ipd-billing-active-service-list', {
        method: 'GET',
        query: query
      });
      if (response.success && Array.isArray(response.data)) {
        const filteredData = response.data.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setIpdBillingDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setIpdBillingDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setIpdBillingDataObj({ loading: false, data: [] });
    }
  };

  useEffect(() => {
    handleSearchPartialCancellation();
  }, [input]);

  const handleSearchPartialCancellation = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    setPartialCancellationDataObj({ loading: true, data: [] });
    try {
      const query = {};
      if (lowercasedInput) {
        query.patientName = lowercasedInput;
      }
      const response = await request('/partial-cancellation-list', {
        method: 'GET',
        query: query
      });
      if (response.success && Array.isArray(response.data)) {
        const filteredData = response.data.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setPartialCancellationDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setPartialCancellationDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setPartialCancellationDataObj({ loading: false, data: [] });
    }
  };

  const isRowSelected = (row, field) => {
    if (!Array.isArray(selectedRows)) {
      return false;
    }
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }
    if (!Array.isArray(selectedRows)) {
      setSelectedRows([]);
      return;
    }
    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);
      if (existingRow) {
        if (existingRow[field]) {
          return prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id);
        } else {
          return prevSelectedRows.map((selectedRow) =>
            selectedRow._id === row._id ? { ...selectedRow, [field]: true } : selectedRow
          );
        }
      } else {
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };

  const handleChange = (e) => {
    setInput(e.target.value);
  };

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                pb: 0.5,
                mb: 3,
                borderBottom: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Partial Cancellation
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                {/* <CustomButtonn
                                    variant="contained"
                                    onClick={() => window.open(`/print${pathname}/ProgressReport?refId=${selectedRecord._id}`, '_blank')}
                                >
                                    Progress Report
                                </CustomButtonn> */}
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled
                  onClick={() => {
                    setCurrentAction();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Grid container spacing={2}>
              <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Voucher Type
                  </Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="voucher_type"
                    placeholder=""
                    menus={VOUCHER_TYPE_DROPDOWN}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    UHID / Adm No.
                  </Typography>
                  <TextField
                    inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                    disabled
                    sx={{ flex: 0.4 }}
                    name="uhid"
                    placeholder=""
                  />
                  <TextField
                    inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                    disabled
                    sx={{ flex: 0.4 }}
                    name="ipd_no"
                    placeholder=""
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Cancellation Date</Typography>
                  <TextField
                    inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8 }}
                    name="cancellation_date"
                    type="date"
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Pay Mode
                  </Typography>
                  <SelectTag
                    menus={RECEIPT_MODE}
                    disabled
                    formControlSX={{ flex: 0.8 }}
                    name="pay_mode"
                    placeholder=""
                  />
                </Stack>
              </Grid>
              <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Bill No.
                  </Typography>
                  <TextField
                    inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                    disabled
                    sx={{ flex: 0.7 }}
                    name="bill_no"
                    placeholder=""
                  />
                  <Button
                    disabled={!['new', 'edit'].includes(currentAction) || !watch('voucher_type')}
                    sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                    variant="contained"
                    onClick={() => {
                      if (watch('voucher_type') === 'OPD BILLING') {
                        fetchOpdBillingList();
                      } else if (watch('voucher_type') === 'IPD BILLING') {
                        fetchIpdBillingList();
                      }
                    }}
                  >
                    <SearchIcon />
                  </Button>
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Patient Name
                  </Typography>
                  <TextField
                    inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                    disabled
                    sx={{ flex: 0.8 }}
                    name="patient_name"
                    placeholder=""
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Authority
                  </Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="authority"
                    placeholder="Select Authority"
                    menus={authorityMaster.map((data) => ({ ...data, name: data.authority }))}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                  <TextField
                    inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.8 }}
                    name="remarks"
                    placeholder=""
                  />
                </Stack>
              </Grid>
              <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Bill Date
                  </Typography>
                  <TextField
                    inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                    disabled
                    sx={{ flex: 0.8 }}
                    name="bill_date"
                    type="date"
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Cancellation No.
                  </Typography>
                  <TextField
                    inputProps={{ style: { fontSize: '1.5rem', padding: '5px' } }}
                    disabled
                    sx={{ flex: 0.8 }}
                    name="cancellation_no"
                    placeholder=""
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Cancel Reason
                  </Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.8 }}
                    name="cancel_reason"
                    menus={reasonMaster.map((data) => ({ ...data, name: data.reason }))}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} sx={{ minHeight: '36rem' }}>
                <Stack spacing={0.5} sx={{ flexDirection: 'column', height: '100%' }}>
                  <Box sx={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}>
                    <SelectDoctorTable
                      data={detailList?.map((item) => ({ ...item, _id: item.service })) || []}
                      columns={SERVICE_ITEMS_TABLE_HEADER}
                      size="small"
                      showInputField={true}
                      showOk={true}
                      isSelected={isRowSelected}
                      handleRowSelect={handleRowSelect}
                      currentAction={selectedRecord ? '' : 'new'}
                      selectedRows={selectedRows}
                    />
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={openOpdBillingDialog}
        onClose={() => setOpdBillingDataObj(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" borderColor="grey.300">
          <Typography variant="h4" fontWeight="bold">
            Opd Billing Query Window
          </Typography>
          <IconButton onClick={() => setOpenOpdBillingDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '16px',
                fontWeight: '700'
              },
              '& .MuiOutlinedInput-input': {
                padding: '6px 14px'
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={opdInput}
            onChange={handleOpdChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={opdBillingDataObj?.data || []}
          loading={opdBillingDataObj.loading}
          onRowClick={(row) => {
            setOpdBillingSelectedRecord(row);
            setOpenOpdBillingDialog(false);
          }}
        />
      </Dialog>

      <Dialog
        open={openIpdBillingDialog}
        onClose={() => setIpdBillingDataObj(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" borderColor="grey.300">
          <Typography variant="h4" fontWeight="bold">
            Ipd Billing Query Window
          </Typography>
          <IconButton onClick={() => setOpenIpdBillingDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '16px',
                fontWeight: '700'
              },
              '& .MuiOutlinedInput-input': {
                padding: '6px 14px'
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={ipdInput}
            onChange={handleIpdChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={IPD_BILLING_TABLE_HEADER}
          data={ipdBillingDataObj?.data || []}
          loading={ipdBillingDataObj.loading}
          onRowClick={(row) => {
            setIpdBillingSelectedRecord(row);
            setOpenIpdBillingDialog(false);
          }}
        />
      </Dialog>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between" borderColor="grey.300">
          <Typography variant="h4" fontWeight="bold">
            Partial Cancellation Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '16px',
                fontWeight: '700'
              },
              '& .MuiOutlinedInput-input': {
                padding: '6px 14px'
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={PARTIAL_CANCELLATION_TABLE_HEADER}
          data={partialCancellationDataObj?.data || []}
          loading={partialCancellationDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
